const OPERATIONS = {
  addition: '+',
  subtraction: '-',
  multiplication: '\u00d7',
  division: '\u00f7',
};

function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function shuffle(array) {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export function generateQuestion(operation) {
  let num1, num2, answer, op;

  if (operation === 'mixed') {
    const ops = ['addition', 'subtraction', 'multiplication', 'division'];
    op = ops[random(0, 3)];
  } else {
    op = operation;
  }

  switch (op) {
    case 'addition':
      num1 = random(1, 50);
      num2 = random(1, 50);
      answer = num1 + num2;
      break;
    case 'subtraction':
      num1 = random(10, 100);
      num2 = random(1, num1 - 1);
      answer = num1 - num2;
      break;
    case 'multiplication':
      num1 = random(1, 12);
      num2 = random(1, 12);
      answer = num1 * num2;
      break;
    case 'division':
      num2 = random(2, 12);
      answer = random(1, 12);
      num1 = num2 * answer;
      break;
    default:
      num1 = random(1, 50);
      num2 = random(1, 50);
      answer = num1 + num2;
      op = 'addition';
  }

  return { num1, num2, operation: op, symbol: OPERATIONS[op], answer };
}

const BALLOON_COLORS = [
  'bg-red-500',
  'bg-blue-500',
  'bg-yellow-400',
  'bg-emerald-500',
  'bg-purple-500',
  'bg-pink-500',
  'bg-cyan-500',
  'bg-orange-500',
];

function generateDistractorNumbers(num1, num2, answer, op) {
  const distractors = new Set();

  // Numbers close to correct answers
  const offsets = [1, 2, 3, -1, -2, -3];
  for (const off of offsets) {
    const d1 = num1 + off;
    const d2 = num2 + off;
    if (d1 > 0 && d1 !== num1 && d1 !== num2) distractors.add(d1);
    if (d2 > 0 && d2 !== num1 && d2 !== num2) distractors.add(d2);
  }

  // Add the answer itself as distractor (it's a number but not part of the equation operands)
  if (answer !== num1 && answer !== num2 && answer > 0) {
    distractors.add(answer);
  }

  // Random numbers in range
  for (let i = 0; i < 4; i++) {
    const maxVal = op === 'multiplication' || op === 'division' ? 12 : 50;
    const r = random(1, maxVal);
    if (r !== num1 && r !== num2) distractors.add(r);
  }

  distractors.delete(num1);
  distractors.delete(num2);
  distractors.delete(0);

  return Array.from(distractors).slice(0, 4);
}

export function generateBalloons(question, gameOperation) {
  const { num1, num2, symbol } = question;
  const isMixed = gameOperation === 'mixed';
  const balloons = [];
  let colorIdx = random(0, BALLOON_COLORS.length - 1);
  const getColor = () => {
    const c = BALLOON_COLORS[colorIdx % BALLOON_COLORS.length];
    colorIdx++;
    return c;
  };

  // Correct balloons
  balloons.push({
    id: `num1-${num1}`,
    value: num1,
    display: String(num1),
    type: 'number',
    color: getColor(),
  });
  balloons.push({
    id: `num2-${num2}`,
    value: num2,
    display: String(num2),
    type: 'number',
    color: getColor(),
  });
  balloons.push({
    id: `op-${symbol}`,
    value: symbol,
    display: symbol,
    type: 'operation',
    color: getColor(),
  });

  // Distractor numbers
  const distractors = generateDistractorNumbers(num1, num2, question.answer, question.operation);
  distractors.forEach((d, i) => {
    balloons.push({
      id: `dist-n-${i}-${d}`,
      value: d,
      display: String(d),
      type: 'number',
      color: getColor(),
    });
  });

  // Distractor operations — only in mixed mode
  if (isMixed) {
    const allOps = ['+', '-', '\u00d7', '\u00f7'];
    allOps
      .filter((op) => op !== symbol)
      .forEach((op, i) => {
        balloons.push({
          id: `dist-op-${i}-${op}`,
          value: op,
          display: op,
          type: 'operation',
          color: getColor(),
        });
      });
  }

  return shuffle(balloons);
}

export function checkEquation(slot1, slotOp, slot2, target) {
  if (!slot1 || !slotOp || !slot2) return false;

  const n1 = slot1.value;
  const n2 = slot2.value;
  let result;

  switch (slotOp.value) {
    case '+':
      result = n1 + n2;
      break;
    case '-':
      result = n1 - n2;
      break;
    case '\u00d7':
      result = n1 * n2;
      break;
    case '\u00f7':
      result = n2 !== 0 ? n1 / n2 : null;
      break;
    default:
      return false;
  }

  return result === target;
}
